import { VIEW_MANAGEMENT } from 'store/types'

function showProgressBar() {
  return {
    type: VIEW_MANAGEMENT.SHOW_PROGRESS_BAR,
  }
}

export default showProgressBar
